<template>
  <div>
    <imgHeader imgUrl="/img/5组织架构-banner.jpg" />
    <div class="w container">
      <h3 class="title" style="text-align: center">{{ $t('architecture.title') }}</h3>
      <div class="line line1"></div>
      <p class="company">{{ $t('architecture.companyName') }}</p>
      <div class="bg" data-aos="flip-left" data-aos-duration="1000">
        <img src="/img/5组织架构-框.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Architecture',
}
</script>

<style lang="scss" scoped>
.company {
  margin: 64px 0 96px;
  color: #666;
  font-size: 18px;
  text-align: center;
}
.container {
  margin-bottom: 90px;
}
.bg {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 648px;
  text-align: center;
  background: url('/img/5组织架构-地图背景_03.png') no-repeat 50%;
}
</style>